import React from "react";

const generateUniqueId = () => {
  return `id-${Date.now().toString(36)}-${Math.random()
    .toString(36)
    .substr(2, 5)}`;
};

type Props = React.InputHTMLAttributes<HTMLInputElement> & {
  label: string | React.ReactNode;
  answer?: boolean;
  setAnswer: (value: boolean) => void;
  labelClass?: string;
};
export const YesNoRadioButtonsField: React.FC<Props> = ({
  label,
  answer,
  setAnswer,
  labelClass = "text",
}) => {
  const uniqueId = generateUniqueId();

  const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValue = event.target.value === "Yes";
    setAnswer(selectedValue);
  };

  return (
    <form>
      <div>
        {label && (
          <label htmlFor={"notQuoted"} className={`text ${labelClass}`}>
            {label}
          </label>
        )}
        <fieldset
          role="radiogroup"
          className="form-field radio-button-group"
          style={{ marginBottom: 0 }}
        >
          <div className="yes-no-radio-button-container">
            <input
              id={`yes-${uniqueId}`}
              type="radio"
              name="quoteOutcome"
              value="Yes"
              checked={answer === true}
              onChange={handleOptionChange}
            />
            <label
              className="radio yes-no-radio-button"
              htmlFor={`yes-${uniqueId}`}
            >
              <span>Yes</span>
            </label>
            <input
              id={`no-${uniqueId}`}
              type="radio"
              name="quoteOutcome"
              value="No"
              checked={answer === false}
              onChange={handleOptionChange}
            />
            <label
              className="radio yes-no-radio-button"
              htmlFor={`no-${uniqueId}`}
            >
              <span>No</span>
            </label>
          </div>
        </fieldset>
      </div>
    </form>
  );
};

export default YesNoRadioButtonsField;
